import { render, staticRenderFns } from "./BDXBulkEditForm.vue?vue&type=template&id=c764e7ae&scoped=true"
import script from "./BDXBulkEditForm.vue?vue&type=script&lang=js"
export * from "./BDXBulkEditForm.vue?vue&type=script&lang=js"
import style0 from "./BDXBulkEditForm.vue?vue&type=style&index=0&id=c764e7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c764e7ae",
  null
  
)

export default component.exports